// extracted by mini-css-extract-plugin
export var image = "index-module--image--ad3ee";
export var learnMore = "index-module--learnMore--b16e2";
export var title = "index-module--title--79ea1";
export var wrapper = "index-module--wrapper--ea14f";